module.exports = __webpack_public_path__ + "static/google-logo.png";